import { Component, OnInit, ViewChild } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import { DropzoneComponent , DropzoneDirective,
  DropzoneConfigInterface } from 'dropzone/dist/dropzone-amd-module';
import { FileUploader } from 'ng2-file-upload';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';


@Component({
  selector: 'app-galary',
  templateUrl: './galary.component.html',
  styleUrls: ['./galary.component.scss']
})
export class GalaryComponent implements OnInit {


  uploader:FileUploader;
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;
  fileToUpload: any;
  galary: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("lgModal", {static: true}) lgModal;
  @ViewChild("viewModal", {static: true}) viewModal;
  isLoading: boolean;
  img: any;
  dltID: any;
  removeEvt: any;
  page: any;
  totalRec: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifierService: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.getAllImages(1);
  }

  ngOnInit() {

  }
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showCropper = false;

  @ViewChild(ImageCropperComponent, {static: false}) imageCropper: ImageCropperComponent;



  upload() {
    this.isLoading =true;
    this.userService.uploadAllGalaryImage( this.files[0]).subscribe(
      data => {
        if(data.responseCode==200){
          this.isLoading =false;
          this.notifierService.notify('success', data.responseDesc);
          this.files=[];
          this.getAllImages(this.currentPage)
        }else {
          this.isLoading =false;
          this.notifierService.notify('danger', data.responseDesc);
        }
      });
  }
  getAllImages(pageIndex){
    let size = 10;
    let page = pageIndex - 1;
    this.userService.getAllGalary().subscribe(
      res=>{
        if(res.responseCode==200){
          this.galary =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }


  view( view,id) {
    view.show();
    this.userService.getAllGalaryImage(id).subscribe(
      res=>{
        if(res.responseCode==200){
          this.img =res.data;
        }else {
          this.notifierService.notify('danger',  res.responseDesc);
        }
      }
    )
  }

  openModal(errorModal, id: any) {
    this.dltID=id;
    this.modalRef = this.modalService.show(errorModal, {class: 'modal-dialog-centered'});
  }


  declineCancel() {
    this.modalRef.hide();
  }

  confirmCancel() {
      this.userService.deleteGalaryImg(this.dltID).subscribe(
        res=>{
          if(res.responseCode==200){
            this.getAllImages(this.currentPage);
            this.modalRef.hide();
            this.notifierService.notify('success',  res.responseDesc);
          }else {
            this.notifierService.notify('danger',  res.responseDesc);
          }
        }
      )
  }

  files: File[] = [];
  itForm: any;
  currentPage: any;

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.removeEvt=event;
    this.files.splice(this.files.indexOf(event), 1);
  }
}
